import React, { useState, useEffect } from "react";
import PricingPackages from "./PricingBlock_FinalWithButtons_Rus";
import "./App.css";
const navigationLinks = [
  { href: "#about", label: "О нас" },
  { href: "#why", label: "Почему МЫ" },
  { href: "#steps", label: "Как работаем" },
  { href: "#examples", label: "Примеры" },
  { href: "#export", label: "Экспорт" },
  { href: "#faq", label: "FAQ" },
  { href: "#packages", label: "Пакеты" },
  { href: "#contact", label: "Контакты" },
];

function AccordionItem({ question, answer }) {
  const [open, setOpen] = useState(false);

  return (
    <div className="border-b border-gray-600 py-4">
      <div
        style={{ cursor: "pointer", display: "flex", justifyContent: "center", alignItems: "center" }}
        onClick={() => setOpen(!open)}
      >
        <h3 style={{ fontSize: "18px", fontWeight: "bold", color: "#facc15", margin: 16 }}>
          {question}
        </h3>
        <span style={{ color: "#22c55e", fontSize: "20px", fontWeight: "bold" }}>{open ? "▲" : "▼"}</span>
      </div>
      {open && <p style={{ marginTop: "8px", color: "#fff", fontSize: "18px" }}>{answer}</p>}
    </div>
  );
}





export default function HomePageRus() {
const [formSuccess, setFormSuccess] = useState(false);
const [menuOpen, setMenuOpen] = useState(false);
const [activeSection, setActiveSection] = useState("");

useEffect(() => {
  const sections = document.querySelectorAll("section[id], footer[id]");

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setActiveSection(entry.target.id);
        }
      });
    },
    { threshold: 0.3 }
  );

  sections.forEach((section) => observer.observe(section));

  // Отслеживаем, когда пользователь доскроллил до самого низа
  const handleScroll = () => {
    const scrollY = window.scrollY;
    const windowHeight = window.innerHeight;
    const fullHeight = document.body.scrollHeight;

    if (scrollY + windowHeight >= fullHeight - 10) {
      setActiveSection("contact"); // Вручную активируем футер
    }
  };

  window.addEventListener("scroll", handleScroll);

  return () => {
    observer.disconnect();
    window.removeEventListener("scroll", handleScroll);
  };
}, []);

const scrollToForm = (selectedPackage) => {
    const target = document.getElementById("request-form");
    if (target) {
      target.scrollIntoView({ behavior: "smooth" });
    }
  };
  return (
    <div style={{ backgroundColor: "#000", color: "#fff", fontFamily: "sans-serif", minHeight: "100vh" }}>
     
<nav
  style={{
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    backgroundColor: "#121212",
    padding: "20px 32px",
    zIndex: 1000,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "nowrap",
    boxSizing: "border-box",
  }}
>
  {/* Левая часть: бургер-иконка на мобильных */}
  <div className="md:hidden" style={{ display: "block" }}>
    <button onClick={() => setMenuOpen(!menuOpen)} style={{ color: "#facc15", fontSize: "28px", border: "none", background: "none" }}>
      ☰
    </button>
  </div>

  {/* Центр: меню (desktop only) */}
  <div className="hidden md:flex" style={{ display: "none" }}>
    {navigationLinks.map((link) => (
      <a
        key={link.href}
        href={link.href}
        className={`nav-link ${activeSection === link.href.slice(1) ? "active" : ""}`}
        style={{ color: "#fff", textDecoration: "none", fontWeight: "bold", marginRight: "16px" }}
      >
        {link.label}
      </a>
    ))}
  </div>

  {/* Правая часть: языки */}
  <div style={{ display: "flex", gap: "12px" }}>
    <a href="/" style={{ color: "#facc15", fontWeight: "bold", textDecoration: "none" }}>UA</a>
    <a href="/ru" style={{ color: "#facc15", fontWeight: "bold", textDecoration: "none" }}>RU</a>
  </div>
</nav>

{menuOpen && (
  <div
    style={{
      position: "fixed",
      top: 0,
      right: 0,
      width: "70%",
      height: "100%",
      backgroundColor: "#1a1a1a",
      zIndex: 999,
      padding: "30px 20px",
      display: "flex",
      flexDirection: "column",
      gap: "20px",
      transition: "right 0.3s ease-in-out",
    }}
  >
    <button onClick={() => setMenuOpen(false)} style={{ alignSelf: "flex-end", fontSize: "24px", color: "#facc15", background: "none", border: "none" }}>
      ✕
    </button>
    {navigationLinks.map((link) => (
      <a
        key={link.href}
        href={link.href}
        onClick={() => setMenuOpen(false)}
        style={{
          color: "#facc15",
          fontWeight: "bold",
          fontSize: "18px",
          textDecoration: "none",
        }}
      >
        {link.label}
      </a>
    ))}
  </div>
)}




      <section style={{ padding: "0px 20px 80px", textAlign: "center" }}>
        <img
          src="/images/logo-transparent.png"
          alt="Autopodbor.lt Logo"
          style={{ width: "100%", maxWidth: "400px", height: "auto", marginBottom: "-30px" }}
        />
        <h1 style={{ fontSize: "36px", fontWeight: "bold", marginBottom: "20px" }}>
          Профессиональный автоподбор в Литве и на экспорт
        </h1>
        <p style={{ color: "#ccc", fontSize: "18px", marginBottom: "30px" }}>
          Техническая проверка, проверенные авто, честные отчёты.
        </p>
        <a href="#request-form">
          <button style={{
            backgroundColor: "#facc15",
            color: "#000",
            padding: "12px 24px",
            fontWeight: "bold",
            borderRadius: "8px",
            cursor: "pointer",
            border: "none"
          }}>
            Оставить заявку
          </button>
        </a>
      </section>

      <section id="about" style={{ padding: "120px 20px", textAlign: "center", backgroundColor: "#121212" }}>
        <h2 style={{ fontSize: "32px", marginBottom: "30px" }}>О нас</h2>
        <p style={{ maxWidth: "800px", margin: "0 auto", fontSize: "18px", color: "#fff" }}>
          Autopodbor.lt — это команда профессионалов с опытом более 10 лет в сфере автомобильного подбора и диагностики, а также экспорта автомобилей в Украину.
          Мы подбираем автомобили с честной историей, делаем полную проверку и сопровождаем клиента на всех этапах покупки — от звонка до вручения авто.
        </p>
      </section>

      <section id="why" style={{ padding: "120px 20px", textAlign: "center" }}>
        <h2 style={{ fontSize: "32px", marginBottom: "30px" }}>Почему выбирают нас</h2>
        <div style={{
          maxWidth: "800px",
          margin: "0 auto",
          display: "flex",
          flexDirection: "column",
          gap: "0px",
          fontSize: "18px",
          lineHeight: "1.6",
          color: "#fff"
        }}>
          <p>🇱🇹 Мы находимся и работаем в Литве, а не живём в гостиницах за операционный бюджет. Мы досконально знаем местный рынок изнутри, а так же его сезонные колибания: где искать хорошие машины которых попросту нет в интернете и распродаются автовозами, какие места лучше обходить стороной, а куда и вовсе не нужно даже и смотреть.</p>
          <p>📊 У нас отличное понимание рыночных цен, "дна" и "потолка" стоимости автомобиля. Это позволяет точно определить, стоит ли конкретный экземпляр своих денег.</p>
          <p>🔧 Многолетний опыт позволяет "видеть трупа за версту", а наличие профессионального оборудования, а так же доскональные знания как им пользоваться — выявить скрытые технические проблемы, включая ошибки, состояние жидкостей, шин, АКБ и многое другое.</p>
          <p>🌍 Рынок Литвы на 70–80% состоит из авто, привезённых из Западной Европы. Здесь особенно важны навыки и опыт, чтобы выбрать не просто красивую обёртку с пробегом 500+ тыс. км, а надёжный автомобиль, с реальным пробегом и понятной историей.</p>
          <p>⚖️ Мы также проверяем юридическую чистоту автомобиля, чтобы защитить клиента от покупки проблемной или криминальной машины.</p>
        </div>
      </section>

      <section id="steps" style={{ padding: "120px 20px", textAlign: "center", backgroundColor: "#121212" }}>
        <h2 style={{ fontSize: "32px", marginBottom: "40px" }}>Как мы работаем</h2>
        <ol style={{ maxWidth: "600px", margin: "0 auto", textAlign: "left", fontSize: "18px", lineHeight: 2 }}>
          <li>
            Вы оставляете заявку, прикрепив ссылку на интересующий вас автомобиль с сайтов{" "}
            <a href="https://www.autoplius.lt" target="_blank" rel="noopener noreferrer" style={{ color: "#facc15", textDecoration: "underline" }}>
              www.autoplius.lt
            </a>{" "}
            или{" "}
            <a href="https://www.autogidas.lt" target="_blank" rel="noopener noreferrer" style={{ color: "#facc15", textDecoration: "underline" }}>
              www.autogidas.lt
            </a>, либо без ссылки, если ещё не определились с выбором.
          </li>
          <li>
            Мы уточняем детали, бюджет, ваши потребности, консультируем, помогаем определиться с{" "}
            <a href="#packages" style={{ color: "#facc15", textDecoration: "underline" }}>
              пакетом услуг
            </a>.
          </li>
          <li>После того как мы согласовали детали и определились с продуктом, вы оплачиваете выбранный пакет.</li>
          <li>
  Анализируем предложения на рынке, ищем авто, делаем проверку согласно выбранному пакету услуг. Если вы выбрали пакет{" "}
  <span style={{ color: "#facc15", fontWeight: "bold" }}>STANDART</span> или{" "}
  <span style={{ color: "#facc15", fontWeight: "bold" }}>PROFI</span>, наш специалист предоставляет вам отчёт в течение{" "}
  <span style={{ color: "#facc15" }}>24 часов</span> после оплаты соответствующего пакета.
</li>

          <li>
            Если после предоставленного отчёта специалистом <strong>Autopodbor.lt</strong> вы принимаете решение о более глубокой диагностике, выкупе или импорте авто (т. е. повышении пакета), вы просто доплачиваете разницу между пакетами.
          </li>
          <li>
            Передаём авто, подготавливаем к регистрации, оформляем экспорт/импорт, организуем доставку вместе с правом собственности. Всё — согласно пожеланиям и выбранному пакету услуг.
          </li>
        </ol>
      </section>

      <section id="examples" style={{ padding: "120px 20px", textAlign: "center" }}>
  <h2 style={{ fontSize: "32px", marginBottom: "40px" }}>Примеры подобранных авто</h2>
  <p style={{ color: "#fff", maxWidth: "700px", margin: "0 auto 30px", lineHeight: "1.6", fontSize: "18px" }}>
    Мы не используем случайные фотографии или выдуманные кейсы с несуществующими отзывами — вместо этого показываем реальные истории из нашей работы.
Каждый день публикуем подборы, диагностики, осмотры, сделки, доставку, а также автомобильный live-контент в наш TikTok-канал.

    Это не витрина с красивыми картинками — это живое подтверждение того, что мы действительно работаем в Литве, подбираем автомобили и честно показываем весь процесс.

    Если хочешь увидеть, как мы работаем, кого мы обслуживаем и какие машины реально находим — просто загляни на наш TikTok. Там всё по-настоящему.
  </p>

 <a
  href="https://www.tiktok.com/@autopodbor.lt"
  target="_blank"
  rel="noopener noreferrer"
  style={{
    display: "inline-flex",
    alignItems: "center",
    backgroundColor: "#1a1a1a",
    color: "#facc15",
    padding: "12px 20px",
    border: "2px solid #facc15",
    borderRadius: "10px",
    fontWeight: "bold",
    fontSize: "16px",
    textDecoration: "none"
  }}
>
  {/* Логотип */}
  <img
    src="/images/logo-transparent.png"
    alt="Autopodbor.lt"
    style={{ width: "80px", height: "80px", marginRight: "10px", objectFit: "contain" }}
  />

  {/* Иконка TikTok */}
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 256 256"
    fill="#facc15"
    style={{ marginRight: "10px" }}
  >
    <path d="M224,80a48.05,48.05,0,0,1-48-48,8,8,0,0,0-8-8H136a8,8,0,0,0-8,8V160a24,24,0,1,1-24-24,8,8,0,0,0,0-16,40,40,0,1,0,40,40V88.29A95.6,95.6,0,0,0,192,104a96.11,96.11,0,0,0,32-5.54,8,8,0,0,0,0-15.1A80.22,80.22,0,0,1,224,80Z"/>
  </svg>

  Смотреть TikTok
</a>

</section>


     <section id="export" style={{ padding: "120px 20px", textAlign: "center", backgroundColor: "#121212" }}>
  <h2 style={{ fontSize: "32px", marginBottom: "40px" }}>Экспорт автомобилей</h2>
  
  <div style={{ maxWidth: "900px", margin: "0 auto", textAlign: "left", color: "#fff", fontSize: "18px", lineHeight: "1.8" }}>

    <p style={{ marginBottom: "30px" }}>
      Литва уже много лет считается <span style={{ color: "#facc15", fontWeight: "bold" }}>экспортным хабом всей Европы</span>. Через неё проходят сотни тысяч автомобилей в год, и на это есть весомые причины.
    </p>

    <p style={{ marginBottom: "30px" }}>
      Во-первых, <span style={{ color: "#facc15" }}>ремонт и предпродажная подготовка в Литве значительно дешевле</span>, чем в Германии, Бельгии или Нидерландах. Именно здесь выгодно делать мелкие кузовные и технические работы перед отправкой машины конечному покупателю.
    </p>

    <p style={{ marginBottom: "30px" }}>
      Во-вторых, в Литве давно выстроена удобная инфраструктура под экспорт: склады, логистика, автовозы, перегонщики, оформление транзитных номеров, экспортных деклараций и страховок — всё это делается быстро и по отлаженной схеме.
    </p>

    <p style={{ marginBottom: "30px" }}>
      Благодаря этому Литва стала ключевым узлом не только для стран СНГ, но и для <span style={{ color: "#facc15" }}>реэкспорта</span> обратно в Западную Европу. Да, даже дилеры из Германии, Польши, Чехии выкупают машины здесь — после местной подготовки они становятся выгодными даже для западного рынка.
    </p>

    <h3 style={{ fontSize: "24px", marginTop: "60px", marginBottom: "20px", color: "#fff" }}>🌍 Основные направления экспорта</h3>
    <ul style={{ paddingLeft: "20px", marginBottom: "30px" }}>
      <li style={{ marginBottom: "10px" }}>🇺🇦 <strong>Украина</strong> — главный рынок. Мы сопровождаем экспорт «под ключ».</li>
      <li style={{ marginBottom: "10px" }}>🇰🇿 Казахстан</li>
      <li style={{ marginBottom: "10px" }}>🇧🇾 Беларусь</li>
      <li style={{ marginBottom: "10px" }}>🇪🇺 Страны Западной Европы (реэкспорт)</li>
    </ul>

    <p style={{ marginBottom: "10px" }}>
      Мы берём на себя <span style={{ color: "#facc15" }}>всё</span>: подбор авто, оформление документов, экспортные номера, страховку, логистику и передачу автомобиля. 
    </p>
    <p style={{ marginBottom: "10px" }}>
      Работаем с фото- и видеоотчётами, координируем процессы на границе, и всегда держим клиента в курсе.
    </p>

    <p style={{ marginTop: "30px" }}>
      Хотите экспортировать автомобиль из Литвы? Просто скажите — мы всё организуем.
    </p>

  </div>
</section>


      <section id="faq" style={{ padding: "120px 20px", textAlign: "center" }}>
  <h2 style={{ fontSize: "32px", marginBottom: "40px" }}>Часто задаваемые вопросы</h2>
  <div className="max-w-3xl mx-auto text-left">
    {[
      {
        q: "Сколько длится подбор автомобиля?",
        a: "Обычно подбор занимает от 1 до 15 рабочих дней, в зависимости от ваших требований и бюджета.",
      },
      {
        q: "Где вы подбираете автомобили?",
        a: "Мы подбираем автомобили в Литве. Основная масса авто поступает из Германии, Бельгии, Нидерландов и Франции.",
      },
      {
        q: "Как проверяется автомобиль перед покупкой?",
        a: "Мы проверяем историю по VIN, юридическую чистоту, техническое состояние, визуальное состояние и проводим тест-драйв. Более подробно ознакомиться с этапами проверки можно в разделе «Как мы работаем» и в описании выбранного пакета услуг.",
      },
      {
        q: "Вы помогаете с регистрацией автомобиля?",
        a: "Да, берём на себя всю процедуру регистрации в Литве и Украине — от подготовки документов до постановки на учёт.",
      },
      {
        q: "Какие документы я получу при покупке?",
        a: "Полный комплект: договор купли-продажи, техпаспорт, техосмотр (если имеется), COC-сертификат, сертификат соответствия, импортная декларация, а также наш подробный отчёт о проверке автомобиля.",
      },
      {
        q: "Можно ли заказать подбор удалённо?",
        a: "Конечно! Всё общение проходит онлайн. Вы получаете фото, видео и отчёты по каждому предложенному варианту.",
      },
      {
        q: "А если мне не подойдёт ни один из вариантов?",
        a: "Мы работаем до победного результата либо до момента, пока клиент сам не остановит процесс по собственным причинам. В случае прекращения подбора по инициативе клиента, возврат средств осуществляется с учётом перерасчёта оплаченного пакета и объёма выполненных работ.",
      },
      {
        q: "Какие гарантии вы даёте?",
        a: "Мы действуем согласно публичной оферты, с которой можно ознакомиться в соответствующем разделе сайта.",
      },
    ].map((item, i) => (
      <AccordionItem key={i} question={item.q} answer={item.a} />
    ))}
  </div>
</section>


      <section id="packages">
  <PricingPackages scrollToForm={scrollToForm} />
</section>

      <section id="request-form" style={{ backgroundColor: "#121212", padding: "100px 20px", textAlign: "center" }}>
        <h2 style={{ fontSize: "32px", marginBottom: "30px", color: "#fff" }}>Оставить заявку</h2>
        <form
          onSubmit={async (e) => {
const form = e.target;
            e.preventDefault();const isBot = form.website.value;
if (isBot) return;

         
            const name = form.name.value;
            const phone = form.phone.value;
            const budget = form.budget.value;
            const selectedPackage = form.package.value;
            const comment = form.comment.value;

            const message = `📥 Новая заявка с сайта Autopodbor.lt\n👤 Имя: ${name}\n📞 Телефон: ${phone}\n💰 Бюджет: ${budget}\n📦 Пакет: ${selectedPackage}\n📝 Комментарий: ${comment || "—"}`;

            const botToken = "7729228635:AAGPTRp2Lo-gZ1tKpriWZKXTWKLZQX3okus";
            const chatId = "6180743887";

            const url = `https://api.telegram.org/bot${botToken}/sendMessage`;

            await fetch(url, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                chat_id: chatId,
                text: message,
              }),
            });

            setFormSuccess(true);
           form.reset();
          }}
          style={{ maxWidth: "500px", margin: "0 auto", display: "flex", flexDirection: "column", gap: "16px" }}
        >
          <input type="text" name="name" placeholder="Ваше имя" required style={{ padding: "12px", borderRadius: "8px", border: "none" }} />
          <input type="tel" name="phone" placeholder="Телефон или WhatsApp" required style={{ padding: "12px", borderRadius: "8px", border: "none" }} />
          <input type="text" name="budget" placeholder="Бюджет (например, 7000 €)" required style={{ padding: "12px", borderRadius: "8px", border: "none" }} />
          <select name="package" defaultValue="" required style={{ padding: "12px", borderRadius: "8px", border: "none" }}>
            <option value="" disabled>Выберите пакет</option>
            <option value="standart">STANDART (100€ + топливо)</option>
            <option value="profi">PROFI (200€ + топливо)</option>
            <option value="premium">PREMIUM (500€ + топливо)</option>
            <option value="vip">VIP «ALL IN» (от 1500€)</option>
          </select>
          <textarea name="comment" placeholder="Комментарий (желания к авто, ссылки и т.д.)" rows="4" style={{ padding: "12px", borderRadius: "8px", border: "none" }} />
<input
  type="text"
  name="website"
  style={{ display: "none" }}
  tabIndex="-1"
  autoComplete="off"
/>
          <button type="submit" style={{ backgroundColor: "#facc15", color: "#000", padding: "14px", fontWeight: "bold", borderRadius: "8px", cursor: "pointer", border: "none", fontSize: "16px" }}>
            Отправить заявку
          </button>
{formSuccess && (
  <p style={{ color: "#22c55e", fontWeight: "bold", marginTop: "20px" }}>
    ✅ Заявка успешно отправлена!
  </p>
)}

        </form>
      </section>

      <footer id="contact" style={{
        backgroundColor: "#1a1a1a",
        padding: "40px 20px",
        display: "flex",
        justifyContent: "center",
        gap: "100px",
        alignItems: "center",
        flexWrap: "wrap",
        color: "#888",
        minHeight: "200px"
      }}>
        <div style={{ textAlign: "left" }}>
          <p>
            © {new Date().getFullYear()} Autopodbor.lt — Все права защищены
            <br />
            <a href="/ru/oferta" style={{ color: "#facc15", fontSize: "14px", textDecoration: "underline" }}>
  Публичная оферта
</a>

          </p>
          <a href="https://www.tiktok.com/@autopodbor.lt" target="_blank" rel="noopener noreferrer" style={{ display: "inline-flex", alignItems: "center", gap: "8px", color: "#ef4444", textDecoration: "none", fontSize: "20px" }}>
            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="currentColor">
              <path d="M16 8.245c1.516 1.005 3.117 1.53 4.932 1.625v3.084c-1.79-.057-3.37-.57-4.932-1.464v5.38c0 5.738-6.663 7.68-9.936 3.454-3.097-3.99-.588-10.253 4.68-10.457v3.163c-2.82.247-3.58 3.162-1.656 4.59 1.735 1.286 3.912-.44 3.912-2.642v-14.978h3.996c.11 2.348.953 4.184 3.004 5.345v3.06c-1.17-.032-2.286-.254-3.392-.687z"/>
            </svg>
            @autopodbor.lt — Наш TikTok канал
          </a>
        </div>

        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
          <img src="/images/logo-transparent.png" alt="Logo" width="100" height="auto" />
          <p style={{ fontSize: "12px", marginTop: "8px" }}>info@autopodbor.lt</p>
          <p style={{ fontSize: "12px", margin: 0 }}>+37061744495</p>
          <p style={{ fontSize: "12px", margin: 0 }}>+380681016108</p>
        </div>

        <div style={{ textAlign: "right", display: "flex", flexDirection: "column", gap: "10px" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <img src="/images/whatsapp-icon.svg" alt="WhatsApp" width="60" height="60" />
            <span>+37061744495</span>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <img src="/images/telegram-icon.svg" alt="Telegram" width="60" height="60" />
            <span>+380681016108</span>
          </div>
        </div>
      </footer>
    </div>
  );
}
